import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import axios from 'axios';
import { useGoogleLogin } from '@react-oauth/google';
import AppleLogin from 'react-apple-login';
// import FacebookLogin from '@greatsumini/react-facebook-login';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { IconApple, IconGoogle } from '../../Icons';
import DataService from '../../services/MisDatosService';
import { RRSSData } from '../../types/PersonalData';
import { useAuthStore } from '../../store/AuthContext';
import useAPIError from '../../hooks/useAPIError';
import { HostProvider } from '../../utils/HostProvider';

const RedesSociales: FC = () => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { addError } = useAPIError();
  const GOOGLE = 'GL';
  const FACEBOOK = 'FB';
  const APPLE = 'AP';
  const isEroski = HostProvider.isEroski();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const props: React.SVGProps<SVGSVGElement> = {
    className: 'facebook-vincular-margin' as string,
  };

  const [recargar, setRecargar] = useState<boolean>(false);
  const [rrssData, setRrssData] = useState<RRSSData>({
    facebookId: '',
    googleId: '',
    appleId: '',
  });
  const clientIdApple = isEroski ? 'www.eroski.signin' : 'www.caprabo.signin';
  const redirectUriApple = isEroski
    ? `${process.env.REACT_APP_BASE_URL}`
    : `${process.env.REACT_APP_BASE_URL_CAPRABO}`;
  const recargarComponente = () => {
    setRecargar(true);
  };
  const appleCallback = (appleResponse: any) => {
    if (appleResponse.authorization && appleResponse.authorization.id_token) {
      const idToken = appleResponse.authorization.id_token;
      const idTokenArr = idToken.split('.');
      const idTokenJson = JSON.parse(atob(idTokenArr[1]));
      const json = {
        appleId: idTokenJson.sub,
      };
      DataService.vincularRrss(json).then((response) => {
        const { data } = response;
        if (!data.error) {
          recargarComponente();
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      });
    }
  };

  // const facebookCallback = (facebookResponse: any) => {
  //   console.log(facebookResponse);
  //   if (facebookResponse.id) {
  //     const json = {
  //       facebookId: facebookResponse.id,
  //     };
  //     DataService.vincularRrss(json).then((response) => {
  //       const { data } = response;
  //       if (!data.error) {
  //         recargarComponente();
  //       } else {
  //         addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
  //       }
  //     });
  //   }
  // };

  const postToUrl = (url: string, params: Record<string, string | number>) => {
    const form = document.createElement('form');
    form.action = url;
    form.method = 'POST';

    Object.entries(params).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  const getUrl = (redSocial: string) => {
    const baseUrl = isEroski
      ? process.env.REACT_APP_API
      : process.env.REACT_APP_API_CAPRABO;

    return `${baseUrl}/${i18n.language}/login/${redSocial}/appclub`;
  };

  const redirigirAappclub = (redSocial: string) => {
    postToUrl(getUrl(redSocial), {
      idioma: i18n.language,
      operacion: 3,
    });
  };

  const googleCb = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      // eslint-disable-next-line no-debugger
      debugger;
      console.log(tokenResponse);
      const userInfo = await axios
        .get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => res.data);
      console.log(userInfo);
      const json = {
        googleId: userInfo.sub,
      };
      DataService.vincularRrss(json).then((response) => {
        const { data } = response;
        if (!data.error) {
          recargarComponente();
        } else {
          addError(
            t(
              data.errorCode === 36
                ? data.userMessage[0].key.replace(/\./g, '-')
                : 'nlr-vaya-algo-no-ha-ido-bien',
            ),
            'WARNING',
          );
        }
      });
    },
    onError: async (errorResponse) => {
      // eslint-disable-next-line no-debugger
      debugger;
      console.log(errorResponse);
    },
  });
  const handleDesvincularClick = (e: any) => {
    e.preventDefault();
    const { id } = e.target;
    let json;
    if (id) {
      switch (id) {
        default:
          json = null;
          break;
        case GOOGLE:
          json = {
            googleId: id,
          };
          break;
        case FACEBOOK:
          json = {
            facebookId: id,
          };
          break;
        case APPLE:
          json = {
            appleId: id,
          };
          break;
      }
      if (json) {
        DataService.desvincularRrss(json).then((response) => {
          const { data } = response;
          if (!data.error) {
            recargarComponente();
          } else {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          }
        });
      }
    }
  };
  const getData = () => {
    DataService.rrss().then((response) => {
      const { data } = response;
      if (data && data.pojo) {
        setRrssData({
          facebookId: data.pojo.facebookId,
          googleId: data.pojo.googleId,
          appleId: data.pojo.appleId,
        });
      }
    });
  };

  function isIOS13OrAbove() {
    if (typeof navigator === 'undefined') return false;

    const ua = navigator.userAgent;

    // Detecta dispositivos iOS
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    if (!isIOS) return false;

    // Buscar versión iOS en el userAgent (ej: "OS 14_2 like Mac OS X")
    const match = ua.match(/OS (\d+)_/i);

    if (match && match[1]) {
      const majorVersion = parseInt(match[1], 10);
      return majorVersion >= 13;
    }

    // Si no puede detectar la versión, asumimos iOS viejo
    return false;
  }

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    setRecargar(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recargar]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
  return (
    <>
      <div className="u-margin-bottom">
        <div className="icon-link-block u-margin-bottom-small">
          {rrssData.googleId ? (
            <>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={handleDesvincularClick}
                className="icon-link u-align-items-baseline"
              >
                <span className="icon icon-medium icon--grey ">
                  <IconGoogle />
                </span>
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={GOOGLE}
                >
                  {t('datos.accessdata.desvincular')}
                </span>
              </a>
            </>
          ) : (
            <>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={() =>
                  dataUser.user.isApp === 'true'
                    ? redirigirAappclub('google')
                    : googleCb()
                }
                className="icon-link u-align-items-baseline"
              >
                <span className="icon icon-medium icon--grey ">
                  <IconGoogle />
                </span>
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={GOOGLE}
                >
                  {t<string>('datos.accessdata.vincular')}
                </span>
              </a>
            </>
          )}
        </div>
        {/* <div className="icon-link-block u-margin-bottom-small"> */}
        {/* {rrssData.facebookId ? ( */}
        {/*  <> */}
        {/*    /!* eslint-disable-next-line jsx-a11y/anchor-is-valid *!/ */}
        {/*    <a */}
        {/*      href="#" */}
        {/*      onClick={handleDesvincularClick} */}
        {/*      className="icon-link u-align-items-baseline" */}
        {/*    > */}
        {/*      <IconFacebook /> */}
        {/*      <p */}
        {/*        className="u-font-small u-text-brand u-text-decoration-underline" */}
        {/*        id={FACEBOOK} */}
        {/*      > */}
        {/*        {t<string>('datos.accessdata.desvincular')} */}
        {/*      </p> */}
        {/*    </a> */}
        {/*  </> */}
        {/* ) : ( */}
        {/*  <> */}
        {/*    <FacebookLogin */}
        {/*      appId="1590403067868532" */}
        {/*      onSuccess={(response) => { */}
        {/*        facebookCallback(response); */}
        {/*        console.log('Login Success!', response); */}
        {/*      }} */}
        {/*      initParams={{ */}
        {/*        version: 'v16.0', */}
        {/*        xfbml: true, */}
        {/*        cookie: true, */}
        {/*      }} */}
        {/*      onFail={(error) => { */}
        {/*        console.log('Login Failed!', error); */}
        {/*      }} */}
        {/*      onProfileSuccess={(response) => { */}
        {/*        console.log('Get Profile Success!', response); */}
        {/*      }} */}
        {/*      render={(renderProps) => ( */}
        {/*        <a */}
        {/*          href="#acceso" */}
        {/*          className="icon-link u-align-items-baseline" */}
        {/*          onClick={renderProps.onClick} */}
        {/*        > */}
        {/*          <span className="icon icon-medium icon--grey "> */}
        {/*            <IconFacebook /> */}
        {/*          </span> */}
        {/*          <p className="u-font-small u-text-brand u-text-decoration-underline"> */}
        {/*            {t<string>('datos.accessdata.vincular')} */}
        {/*          </p> */}
        {/*        </a> */}
        {/*      )} */}
        {/*    /> */}
        {/*  </> */}
        {/* )} */}
        {/* </div> */}
        <div className="icon-link-block">
          {/* eslint-disable-next-line no-nested-ternary */}
          {rrssData.appleId ? (
            <>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={handleDesvincularClick}
                className="icon-link u-align-items-baseline"
              >
                <span className="icon icon-medium icon--grey ">
                  <IconApple />
                </span>
                <span
                  className="u-font-small u-text-brand u-text-decoration-underline"
                  id={APPLE}
                >
                  {t('datos.accessdata.desvincular')}
                </span>
              </a>
            </>
          ) : (
            (dataUser.user.isApp !== 'true' ||
              (dataUser.user.isApp === 'true' && isIOS13OrAbove())) && (
              <>
                <AppleLogin
                  clientId={clientIdApple}
                  redirectURI={redirectUriApple}
                  callback={appleCallback}
                  scope="name email"
                  usePopup
                  render={(renderProps) => (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a
                      href="#"
                      onClick={renderProps.onClick}
                      className="icon-link u-align-items-baseline"
                    >
                      <span className="icon icon-medium icon--grey ">
                        <IconApple />
                      </span>
                      <span
                        className="u-font-small u-text-brand u-text-decoration-underline"
                        id={APPLE}
                      >
                        {t('datos.accessdata.vincular')}
                      </span>
                    </a>
                  )}
                />
              </>
            )
          )}
        </div>
      </div>
    </>
  );
};
export default RedesSociales;
